import React, { FunctionComponent, Fragment } from 'react';
import {
  StyledTitle,
  AutocompleteMenu,
  AutocompleteItemList,
  AutocompleteItem,
} from '../../../core/forms/AutocompleteInput';
import { AffiliationSearch } from '../../../interfaces/register';

interface AffiliationMenu {
  affiliations: AffiliationSearch[];
  stateId: number | null;
}

const AffiliationMenu: FunctionComponent<AffiliationMenu> = ({
  affiliations,
  stateId,
}: AffiliationMenu) => {
  const topResults = stateId
    ? affiliations.filter((affiliation) => affiliation.stateId === stateId)
    : [];
  const matchingResults = affiliations.filter(
    (affiliation) => affiliation.stateId === null
  );

  return (
    <AutocompleteMenu>
      {topResults.length ? (
        <Fragment>
          <StyledTitle color="secondary" bold>
            Top results
          </StyledTitle>
          <AutocompleteItemList items={topResults} />
        </Fragment>
      ) : null}
      {matchingResults.length ? (
        <Fragment>
          <StyledTitle color="secondary" bold>
            Matching results
          </StyledTitle>

          {matchingResults.map(({ label }, index) => (
            <AutocompleteItem
              key={label}
              label={label}
              index={index + topResults.length}
            />
          ))}
        </Fragment>
      ) : null}
    </AutocompleteMenu>
  );
};

export default AffiliationMenu;
